import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
const Component = props => {
  return _jsx(_Fragment, {
    children: _jsxs("svg", Object.assign({
      viewBox: "0 0 30 30",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props, {
      children: [_jsx("mask", {
        id: "wyuy13pdp__mask0_16441_297161",
        style: {
          maskType: "alpha"
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "30",
        height: "30",
        children: _jsx("path", {
          d: "M15 29.5C6.99187 29.5 0.5 23.0081 0.5 15C0.5 6.99187 6.99187 0.5 15 0.5C23.0081 0.5 29.5 6.99187 29.5 15C29.5 23.0081 23.0081 29.5 15 29.5Z",
          fill: "#C4C4C4",
          stroke: "#152361"
        })
      }), _jsxs("g", {
        mask: "url(#wyuy13pdp__mask0_16441_297161)",
        children: [_jsx("path", {
          d: "M37.1628 0H-4V30H37.1628V0Z",
          fill: "#EF2B2D"
        }), _jsx("path", {
          d: "M14.7102 0H7.22607V30H14.7102V0Z",
          fill: "white"
        }), _jsx("path", {
          d: "M37.1628 11.25H-4V18.75H37.1628V11.25Z",
          fill: "white"
        }), _jsx("path", {
          d: "M12.8392 0H9.09717V30H12.8392V0Z",
          fill: "#002868"
        }), _jsx("path", {
          d: "M37.1628 13.125H-4V16.875H37.1628V13.125Z",
          fill: "#002868"
        }), _jsx("path", {
          d: "M15 29C7.26801 29 1 22.732 1 15C1 7.26801 7.26801 1 15 1C22.732 1 29 7.26801 29 15C29 22.732 22.732 29 15 29Z",
          stroke: "#152361",
          strokeWidth: "2"
        })]
      })]
    }))
  });
};
export default Component;
